export const REDUCER_NAME = "unitSlice";

export interface iUnit {
  id: string;
  name: string;
  created_at: string;
  updated_at: string;
}

export interface iUnitState {
  isLoading: boolean;
  unit: iUnit | null;
  errorMessage: string | null;
  unitList: iUnit[];
}